var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-bar"},[_c('div',{staticClass:"return-arow",on:{"click":_vm.home}},[_c('img',{attrs:{"src":require("@/assets/lottery/arow.png")}})]),_c('div',{class:{
      'table-title': true,
      turntable: _vm.isTurntable,
      luckydraw: !_vm.isTurntable,
    }})])}
var staticRenderFns = []

export { render, staticRenderFns }